import { getLocale } from "../runtime";

const da_searchbarlabel = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Hvad leder du efter?`
};

const en_searchbarlabel = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `What are you looking for?`
};

const es_searchbarlabel = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `¿Qué estás buscando?`
};

const fi_searchbarlabel = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Mitä etsit?`
};

const nb_searchbarlabel = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Hva leter du etter?`
};

const sv_searchbarlabel = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Vad letar du efter?`
};

const searchbarlabel = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_searchbarlabel(inputs)
	if (locale === "en") return en_searchbarlabel(inputs)
	if (locale === "es") return es_searchbarlabel(inputs)
	if (locale === "fi") return fi_searchbarlabel(inputs)
	if (locale === "nb") return nb_searchbarlabel(inputs)
	if (locale === "sv") return sv_searchbarlabel(inputs)
	return "searchBarLabel";
};

export { searchbarlabel as "searchBarLabel" };